import React from "react";
import * as styles from "./waves.css";
const Waves = () => (
  <>
    <div class='waves-container'>
      <div class='waves'>
        <svg
          class='svg'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 590 100'
        >
          <defs>
            <linearGradient id='waves-a' x1='0%' y1='50%' y2='50%'>
              <stop offset='0%' stop-color='#009cff' />
              <stop offset='100%' stop-color='#0171b9' />
            </linearGradient>
            <linearGradient
              id='waves-b'
              x1='.258%'
              x2='101.258%'
              y1='49.75%'
              y2='49.75%'
            >
              <stop offset='0%' stop-color='#0171b9' />
              <stop offset='47.525%' stop-color='#53A0FD' />
              <stop offset='100%' stop-color='#073a5a' />
            </linearGradient>
            <linearGradient
              id='waves-c'
              x1='.258%'
              x2='101.258%'
              y1='49.75%'
              y2='49.75%'
            >
              <stop offset='0%' stop-color='#00446f' />
              <stop offset='47.525%' stop-color='#53A0FD' />
              <stop offset='100%' stop-color='#00446f' />
            </linearGradient>
          </defs>
          <path
            class='path-1'
            fill='url(#waves-a)'
            d='M-2.48689958e-14,-7.38298311e-14 C100,-7.38298311e-14 167,50 267,50 C367,50 432,-6.54950269e-14 532,-7.38298311e-14 C632,-8.21565038e-14 700,50 800,50 C800,133.404483 800,150.071149 800,100 L5.20093986e-14,100 C-9.70686797e-17,134.422833 -2.57232001e-14,101.0895 -2.48689958e-14,-7.38298311e-14 Z'
            opacity='.6'
          />
          <path
            class='path-2'
            fill='url(#waves-b)'
            d='M-2.48689958e-14,-7.38298311e-14 C100,-7.38298311e-14 167,50 267,50 C367,50 432,-6.54950269e-14 532,-7.38298311e-14 C632,-8.21565038e-14 700,50 800,50 C800,133.404483 800,150.071149 800,100 L5.20093986e-14,100 C-9.70686797e-17,134.422833 -2.57232001e-14,101.0895 -2.48689958e-14,-7.38298311e-14 Z'
            opacity='.15'
          />
          <path
            class='path-3'
            // #00446f
            fill='url(#waves-c)'
            d='M-2.48689958e-14,-7.38298311e-14 C100,-7.38298311e-14 167,50 267,50 C367,50 432,-6.54950269e-14 532,-7.38298311e-14 C632,-8.21565038e-14 700,50 800,50 C800,133.404483 800,150.071149 800,100 L5.20093986e-14,100 C-9.70686797e-17,134.422833 -2.57232001e-14,101.0895 -2.48689958e-14,-7.38298311e-14 Z'
          />
        </svg>
      </div>
    </div>
  </>
);

export default Waves;
